import React from 'react';
import { TableTypes } from 'components/Table/constants';

export enum SortingTypes {
  ASC = '0',
  DESC = '1',
}

export interface ISortingObject {
  field: string;
  order: SortingTypes;
}

export interface IColumn {
  name: string;
  key: string;
  sortable?: boolean;
  searchable?: boolean;
  width?: number;
  labelAlignment?: string;
  accessor?: (item: any) => React.ReactNode;
  type?: TableTypes;
}

export interface ITableProps {
  resource: string;
  columns: IColumn[];
}
